import * as Amplitude from "@amplitude/analytics-browser"

export default Amplitude;